export const initialProductDetailState = {
  loading: false,
  error: null,
  dataProductDetail: null,
};
